module.exports = __webpack_public_path__ + "static/img/image_article_007.eab4aab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/article_img/image_article_007.png
// module id = OGTG
// module chunks = 0